import {
  Paper,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  TablePagination,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { getTitleColor, formatFileSize, formatDate } from './utils';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import GetAppIcon from '@material-ui/icons/GetApp';
import { FileItem } from './s3-manager-form';
import { getDownloadUrl } from '@api/s3-manager/s3-manager.api';
import { useSnackbar } from 'notistack';
import TableSortLabel from '@material-ui/core/TableSortLabel';

export const FileTable = ({
  title,
  files,
  selectedFolder,
  folder,
}: {
  title: string;
  files: FileItem[];
  selectedFolder: string;
  folder: string;
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const { enqueueSnackbar } = useSnackbar();
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');
  const sortedFiles = [...files].sort((a, b) => {
  const aDate = new Date(a.last_modified).getTime();
  const bDate = new Date(b.last_modified).getTime();

    return sortDirection === 'asc'
      ? aDate - bDate
      : bDate - aDate;
  });
  useEffect(() => {
    setPage(0);
    }, [files]);

    const handleSort = () => {
    setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
  };

  const handleDownload = async (fileName: string, folder: string) => {
    try {
      const response = await getDownloadUrl(selectedFolder, fileName, folder).toPromise();

      const signedUrl = response?.signed_url;

      if (!signedUrl) {
        throw new Error('Download URL not found');
      }

      window.open(signedUrl, '_blank');
    } catch (error) {
      enqueueSnackbar('Failed to download file', {
        variant: 'error',
      });
    }
  };

  return (
    <Paper style={{ padding: 2, height: '100%' }}>
      <Box display="flex" alignItems="center" mb={2}>
        <FolderOpenIcon color="primary" style={{ marginRight: 8, color: getTitleColor(title) }} />
        <Typography
          variant="h6"
          style={{
            color: getTitleColor(title),
            fontWeight: 600,
          }}>
          {title} ({files.length})
        </Typography>
      </Box>
      {!selectedFolder ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight={220}>
          <FolderOpenIcon color="disabled" style={{ fontSize: 60 }} />

          <Typography variant="h6" color="textSecondary" style={{ marginTop: 12 }}>
            Select a Folder
          </Typography>

          <Typography variant="body2" color="textSecondary">
            Choose a folder and click Refresh All to view files.
          </Typography>
        </Box>
      ) : files.length === 0 ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight={220}>
          <InsertDriveFileOutlinedIcon color="disabled" style={{ fontSize: 60 }} />

          <Typography variant="h6" color="textSecondary" style={{ marginTop: 12 }}>
            No Files Found
          </Typography>

          <Typography variant="body2" color="textSecondary">
            Files will appear here once they are available.
          </Typography>
        </Box>
      ) : (
        <>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow style={{ background: '#f5f7fa', borderRadius: 8, marginBottom: 4 }}>
                  <TableCell>S.No.</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>Size</TableCell>
                 <TableCell sortDirection={sortDirection}>
                    <TableSortLabel
                      active
                      direction={sortDirection}
                      onClick={handleSort}
                    >
                      Last Modified
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {sortedFiles
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((file, index) => (
                    <TableRow key={`${file.file_name}-${index}`}>
                      <TableCell style={{ width: 60, fontWeight: 600 }}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell>{file.file_name}</TableCell>
                      <TableCell>{formatFileSize(parseInt(file.size))}</TableCell>
                      <TableCell>{formatDate(file.last_modified)}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          onClick={() =>
                            /* window.open(
                          file.downloadUrl,
                          '_blank'
                        ) */
                            handleDownload(file.file_name, folder)
                          }>
                          <GetAppIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={files.length}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 15]}
            onChangePage={(event, newPage) => {
              setPage(newPage);
            }}
            onChangeRowsPerPage={event => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
          />
        </>
      )}
    </Paper>
  );
};
